import { M as Menu, d as defineCustomElement$1 } from './p-a83b6d5f.js';
const OwcMenu = Menu;
const defineCustomElement = defineCustomElement$1;
export { OwcMenu, defineCustomElement };